angular.module('impactx.rfx').controller('RFXEditDateCtrl', RFXEditDateCtrl);

RFXEditDateCtrl.$inject = ['$scope', 'dataGen', 'TranslationService','ToastService', '$mdDialog', 'RFXBuyerService', 'rfqhId', 'reload'];

function RFXEditDateCtrl($scope, dataGen, TranslationService, ToastService, $mdDialog, RFXBuyerService, rfqhId, reload) {
    var self = this;
    $scope.abortLabel = TranslationService.get("abort");
    $scope.acceptLabel = TranslationService.get("save");
    $scope.requiredLabel = TranslationService.get("required");

    function getData() {
        dataGen.getData($scope, {rfqhId: rfqhId}, "/rfx/buyer/changedates")
    }

    self.apply = function () {
        RFXBuyerService.saveDates($scope, reload).then(function () {
            $mdDialog.hide();
        });
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

    getData();
}